import { connect } from 'react-redux';
import { State } from 'store/types';

import { pinkBoxDataSelector } from '@nykaa/prices-revealed-shared/utils';
import View from './View';

const mapStateToProps = (state: State) => {
  const { remoteConfig, auth } = state;
  const { active = false, pinkBoxUrl } = pinkBoxDataSelector(
    remoteConfig.configs?.priceReveal || {}
  );
  const {
    user: { email, priveBand },
  } = auth || {};
  const isEarlyAccessDay =
    remoteConfig.configs?.isEarlyAccessDay?.active || false;
  const headerPinkBoxDisableBands =
    remoteConfig.configs?.isEarlyAccessDay?.priveBands || [];
  const showPinkBox =
    !isEarlyAccessDay ||
    !priveBand ||
    !headerPinkBoxDisableBands?.includes(priveBand);
  return {
    active,
    pinkBoxUrl,
    email,
    showPinkBox,
  };
};

export default connect(mapStateToProps)(View);
